import { useState, useEffect } from 'react';
import './Pages.css';
import CTA from '../sections/CTA';

// AerialRoot Infotech YouTube channel
const CHANNEL_ID = 'UCJc9N7Yhet_L6x9bhL8uIjQ';
const CHANNEL_URL = 'https://www.youtube.com/@aerialrootinfotech';
const FEED_URL = `https://www.youtube.com/feeds/videos.xml?channel_id=${CHANNEL_ID}`;
// rss2json converts the channel RSS to JSON with CORS enabled (latest ~15 videos)
const API_URL = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(FEED_URL)}`;

function videoIdFrom(item) {
  // guid looks like "yt:video:VIDEO_ID"; fall back to parsing the link
  if (item.guid && item.guid.includes('yt:video:')) return item.guid.split('yt:video:')[1];
  const m = (item.link || '').match(/[?&]v=([\w-]+)/);
  return m ? m[1] : null;
}

function formatDate(d) {
  try {
    return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return '';
  }
}

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [state, setState] = useState('loading'); // loading | ready | error
  const [playing, setPlaying] = useState(null);  // video id currently playing

  useEffect(() => {
    fetch(API_URL)
      .then(r => r.json())
      .then(data => {
        const items = (data.items || [])
          .map(it => ({
            id: videoIdFrom(it),
            title: it.title,
            date: formatDate(it.pubDate),
            thumb: it.thumbnail || (videoIdFrom(it) ? `https://i.ytimg.com/vi/${videoIdFrom(it)}/hqdefault.jpg` : ''),
          }))
          .filter(v => v.id);
        if (items.length === 0) throw new Error('no videos');
        setVideos(items);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, []);

  return (
    <>
      <div className="page-top-spacer" />
      <section className="videos-section">
        <div className="page-header reveal">
          <span className="section-label">Watch & Learn</span>
          <h2 className="section-title">Videos That <em>Grow Your Business</em></h2>
          <p className="section-sub">Tutorials, case studies, and behind-the-scenes from our campaigns — fresh from our YouTube channel.</p>
        </div>

        {state === 'loading' && (
          <div className="videos-status">Loading videos…</div>
        )}

        {state === 'error' && (
          <div className="videos-status">
            <p>Couldn't load videos right now.</p>
            <a href={CHANNEL_URL} target="_blank" rel="noreferrer" className="btn-ghost videos-channel-btn">
              Watch on YouTube →
            </a>
          </div>
        )}

        {state === 'ready' && (
          <>
            <div className="video-grid">
              {videos.map(v => (
                <div key={v.id} className="video-card reveal">
                  <div className="video-thumb">
                    {playing === v.id ? (
                      <iframe
                        src={`https://www.youtube.com/embed/${v.id}?autoplay=1`}
                        title={v.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    ) : (
                      <button
                        type="button"
                        className="video-thumb-btn"
                        onClick={() => setPlaying(v.id)}
                        aria-label={`Play ${v.title}`}
                      >
                        <img src={v.thumb} alt={v.title} loading="lazy" />
                        <span className="video-play">▶</span>
                      </button>
                    )}
                  </div>
                  <div className="video-info">
                    <h3>{v.title}</h3>
                    <p>{v.date}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="videos-channel-cta reveal">
              <a href={CHANNEL_URL} target="_blank" rel="noreferrer" className="btn-ghost">
                View All on YouTube →
              </a>
            </div>
          </>
        )}
      </section>
      <CTA />
    </>
  );
}
